import { render, staticRenderFns } from "./TaxTrustingConfirmationForce.vue?vue&type=template&id=766a39f1&scoped=true"
import script from "./TaxTrustingConfirmationForce.vue?vue&type=script&lang=js"
export * from "./TaxTrustingConfirmationForce.vue?vue&type=script&lang=js"
import style0 from "./TaxTrustingConfirmationForce.vue?vue&type=style&index=0&id=766a39f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a39f1",
  null
  
)

export default component.exports